import { apiFetch } from '@/shared/api/apiClient'
import { metabaseDashboardSchema } from './metabaseDashboard'
import {
  toCockpitDashboard,
  type CockpitDashboard,
} from '@/features/dashboard/model/cockpitDashboard'

/**
 * Calls bristol's `/cockpit/data` endpoint, which re-queries Metabase
 * dashboard 593 (instance `main`) server-side and returns the raw export
 * (see `metabaseDashboard.ts`). No Metabase credentials are involved here —
 * this backend endpoint is the proxy that holds them.
 *
 * The raw response is reshaped into `CockpitDashboard` by
 * `toCockpitDashboard` before it reaches the rest of the app.
 */

export const getCockpitDashboard = async (): Promise<CockpitDashboard> =>
  toCockpitDashboard(
    await apiFetch('/cockpit/data', {
      method: 'POST',
      body: { tab: 'main', markets: [], c_level: [], criticality: [] },
      schema: metabaseDashboardSchema,
    })
  )
